import {IWithSummaryModel} from "../../../../../../common/permission/api/entity/iWithSummary.model";
import {PaymentRequestOnlineAttemptSummaryModel} from "./paymentRequestOnlineAttemptSummary.model";
import {ExternalIdModel} from "../../../../../../common/externalId/api/entity/externalId.model";
import {AccountingAccountModel} from "../../../../../../accounting/account/api/entity/accountingAccount.model";

export class PaymentRequestOnlineAttemptModel implements IWithSummaryModel<PaymentRequestOnlineAttemptSummaryModel> {
    summary: PaymentRequestOnlineAttemptSummaryModel;
    externalId: ExternalIdModel;
    targetAccountingAccount: AccountingAccountModel;
}
